import media from '@/styles/media';
import theme from '@/styles/theme';
import styled, { css } from 'styled-components';

const anchorStyle = css`
  padding: 5px 10px;
  font-size: 14px;
  color: ${theme.color.silver};
  font-family: ${theme.fontFamily.regular};
  align-self: center;

  ${media.md`
    font-size: 12px;
  `}
`;

export const AnchorText = styled.span`
  ${anchorStyle}
  cursor: default;
  margin: 20px 0;
  line-height: 150%;
`;

export const Anchor = styled.a`
  ${anchorStyle}
  text-decoration: underline;
  cursor: pointer;
  &[data-disabled="true"] {
    opacity: .3;
  }
`;
